import React from 'react';
import {notifyError, notifySuccess, useAppDispatch} from "@nutastic/nutastic-react-app";
import FormFieldsEditor from "../../../refactor/formFields/FormFieldsEditor";
import {quickCall} from "../../../state/actions.mjs";
import makeFetchCall from "../../../utils/makeFetchCall";

const UserCredentialsForm = ({ onClose }) => {
    const appDispatch = useAppDispatch();

    const onSaveClick = ({ nuPassword, nuPasswordConfirm, currentPassword }) => {
        appDispatch(quickCall({
            title: 'Updating user information',
            asyncFetchCall: async () => {
                return await makeFetchCall('/api/account/update-info', { nuPassword, nuPasswordConfirm, currentPassword })
            },
            onSuccess: (response) => {
                console.log('User updated', response);
                notifySuccess('Your user credentials have been updated.');
                onClose();
            },
            onError: (response) => {
                console.error('Unable to update credentials', response);
                notifyError(null, 'Update Failed', 'Failed to update. Ensure you entered your old password and nu passwords correctly. Your nu password must be at least 7 characters. Contact us if you have lost your password.');
            }
        }));
    };

    const userCredentialsConfig = [{
        fields: [
            {
                id: 'currentPassword',
                label: 'Enter Your Current Password',
                type: 'PasswordInput'
            },
            {
                id: 'nuPassword',
                label: 'Enter New Password',
                type: 'PasswordInput'
            },
            {
                id: 'nuPasswordConfirm',
                label: 'Confirm Your New Password',
                type: 'PasswordInput'
            }
        ]
    }]

    return <section className="accountsFormWrapper">
        <p>Update your password below</p>
        <FormFieldsEditor
            formConfig={userCredentialsConfig}
            formData={{}}
            className="accountsForm"
            onCancel={onClose}
            onSave={onSaveClick}
        />
    </section>;
};

export default UserCredentialsForm;
